<template>
  <v-toolbar
    id="core-toolbar"
    flat
    prominent
    style="background: #eee;"
  >
    <div class="v-toolbar-title">
      <v-toolbar-title
        class="tertiary--text font-weight-light"
      >
        <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          dark
          icon
          @click.stop="onClickBtn"
        >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ header }}
      </v-toolbar-title>
    </div>

    <v-spacer />
    <v-toolbar-items>
      <v-flex
        align-center
        layout
        py-2
      >
        <v-alert
                v-if="$store.state.app.me.nextScheduledOvertime"
                :value="true"
                dismissible
                color="red"
                border="left"
                elevation="2"
                colored-border
                icon="mdi-alarm"
                class="mx-2"
        >
          <a class="white--text" href="/dashboard?active=prekovremeni">{{$t('Pages.ScheduledOvertimes.note')}} <strong>{{getLocaleDateFormat($store.state.app.me.nextScheduledOvertime.date)}}</strong>.</a>
        </v-alert>
        <v-alert
                v-if="$store.state.app.me.nextTravelWarrant"
                :value="true"
                dismissible
                color="warning"
                border="left"
                elevation="2"
                colored-border
                icon="mdi-checkbook"
                class="mx-2"
        >
          <a class="white--text" href="/dashboard?active=nalozi">{{$t('Pages.TravelWarrants.note')}} <strong>{{getLocaleDateFormat($store.state.app.me.nextTravelWarrant.start)}}</strong>.</a>
        </v-alert>
        <vue-countdown :seconds="timeout" :start="true" v-if="!hasAnyRole([UserRoles.DIRECTOR, UserRoles.REVISER, UserRoles.ADMIN, UserRoles.LOGISTIC, UserRoles.REPORTER]) && hasRole(UserRoles.USER)"></vue-countdown>

        <v-btn flat icon color="tertiary"  to="/dashboard">
          <v-icon color="tertiary">mdi-view-dashboard</v-icon>
        </v-btn>

        <v-dialog
                ref="dialog"
                v-model="calendarModal"
                lazy
                full-width
                width="790px"
        >
          <v-btn slot="activator" flat icon color="tertiary">
            <v-icon color="tertiary">mdi-calendar-star</v-icon>
          </v-btn>

          <v-date-picker first-day-of-week="1" :events="functionEvents" color="indigo" readonly landscape full-width scrollable>
            <v-spacer></v-spacer>
            <v-btn flat @click="calendarModal = false" color="indigo">{{$t('Core.Fields.ok')}}</v-btn>
          </v-date-picker>
        </v-dialog>

        <v-btn flat icon color="tertiary"  to="/user-profile">
          <v-icon color="tertiary">mdi-account</v-icon>
        </v-btn>

        <v-btn @click="logout" flat icon color="tertiary">
          <v-icon>mdi-power</v-icon>
        </v-btn>

      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>

import {
  mapMutations
} from 'vuex'
import VueCountdown from '@dmaksimovic/vue-countdown';
export default {
    components: {VueCountdown},
  data: () => ({
    responsive: false,
    responsiveInput: false,
    calendarModal: false,
  }),
  watch: {
  },
  created(){

    this.getHolidays();
    this.getVacationRequests();
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick () {
      //
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    }
  }
}
</script>

<style>
  #core-toolbar a {
    text-decoration: none;
  }
</style>
